function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import r from "../managers/braze-instance.js";
import c from "../common/event-logger.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import et from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as ot } from "../triggers/triggers-provider-factory.js";
import { validateCustomProperties as rt, validateCustomString as nt } from "../util/validation-utils.js";
import { LOG_CUSTOM_EVENT_STRING as it } from "../common/constants.js";
export function logCustomEvent(t, e) {
  if (!r.rr()) return !1;
  if (null == t || t.length <= 0) return N.error("logCustomEvent requires a non-empty eventName, got \"".concat(t, "\". Ignoring event.")), !1;
  if (!nt(t, "log custom event", "the event name")) return !1;

  var _rt = rt(e, it, "eventProperties", "log custom event \"".concat(t, "\""), "event"),
      _rt2 = _slicedToArray(_rt, 2),
      o = _rt2[0],
      n = _rt2[1];

  if (!o) return !1;
  var i = r.v();
  if (i && i.je(t)) return N.info("Custom Event \"".concat(t, "\" is blocklisted, ignoring.")), !1;
  var s = c.ut(d.CustomEvent, {
    n: t,
    p: n
  });

  if (s.tt) {
    N.info("Logged custom event \"".concat(t, "\"."));

    var _iterator = _createForOfIteratorHelper(s.$e),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o = _step.value;
        ot.m().Ce(et.Ee, [t, e], _o);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return s.tt;
}